const translations: Record<string, string> = {
  "ak_sd_night_no_generation_the_night_draw_of": "Night: no generation, the night draw of 0.05 is included in the schedule",
  "ak_sd_night_no_generation": "Night: no generation",
  "ak_sd_before_sunrise": "Before sunrise",
  "ak_sd_sunrise_the_model_gives_0_6_with_a_0_4": "Sunrise: the model gives 0.6 with a 0.4–0.8 corridor",
  "ak_sd_morning_ramp_historically_the_largest": "Morning ramp - historically the largest error",
  "ak_sd_ramp_continues_variable_cloud_cover": "Ramp continues, variable cloud cover",
  "ak_sd_price_is_already_low_but_the_battery_i": "Price is already low, but the battery is not full yet",
  "ak_sd_zero_hour_all_generation_goes_to_the_b": "Zero hour: all generation goes to the battery",
  "ak_sd_zero_hour_the_battery_takes_the_remain": "Zero hour: the battery takes the remainder",
  "ak_sd_battery_is_full_the_remaining_2_0_goes": "Battery is full, the remaining 2.0 goes to the grid",
  "ak_sd_delivery_per_schedule": "Delivery per schedule",
  "ak_sd_generation_decline": "Generation decline",
  "ak_sd_sunset": "Sunset",
  "ak_sd_almost_no_generation_price_is_rising": "Almost no generation, price is rising",
  "ak_sd_discharge_window_2nd_most_expensive_ho": "Discharge window: 2nd most expensive hour of the day",
  "ak_sd_discharge_window_the_most_expensive_ho": "Discharge window: the most expensive hour of the day",
  "ak_sd_battery_is_empty_no_reserve_for_a_thir": "Battery is empty, no reserve for a third hour",
  "ak_sd_night": "Night",
  "ak_sd_2_inverters_of_tko_3_taken_out_of_serv": "2 inverters of TKO-3 taken out of service, planned until 16.10",
  "ak_sd_connection_to_ems_box_lost_for_6_min_d": "Connection to EMS Box lost for 6 min - data restored",
  "ak_sd_commercial_dispatcher": "Commercial dispatcher",
  "ak_sd_vadym": "Vadym",
  "ak_sd_forecast_quality_and_volumes": "forecast quality and volumes",
  "ak_sd_today_09_12": "today 09:12",
  "ak_sd_trader": "Trader",
  "ak_sd_olya": "Olya",
  "ak_sd_prices_and_charge_discharge_windows": "prices and charge/discharge windows",
  "ak_sd_today_09_31": "today 09:31",
  "ak_sd_technical_dispatcher": "Technical dispatcher",
  "ak_sd_vacancy": "vacancy",
  "ak_sd_technical_state_and_restrictions": "technical state and restrictions",
  "ak_sd_trading_schedule_for_elios_luchky_sola": "Trading schedule for {{d}} · Elios Luchky solar plant",
  "ak_sd_draft_prepared_by_the_model_at_08_40": "Draft prepared by the model at 08:40 ·",
  "ak_sd_approved_by": "approved by {{p}} · {{at}}",
  "ak_sd_waiting": "waiting · {{p}}",
  "ak_sd_if_at": "If at",
  "ak_sd_not_everyone_has_approved_the_system_w": "not everyone has approved - the system will submit its own version and log who did not look. An unsigned schedule is better than none: a day without a schedule cost UAH 33k in September.",
  "ak_sd_mwh": "MWh",
  "ak_sd_k_uah": "k UAH",
  "ak_sd_of": "{{a}} of {{b}}",
  "ak_sd_charge_discharge_mw": "charge {{c}} / discharge {{d}} MW",
  "ak_sd_delivery_ceiling_mw": "delivery ceiling {{n}} MW",
  "ak_sd_each_role_sees_its_own_screen_the_swit": "Each role sees its own screen. The switch here only shows all three in one link.",
  "ak_sd_area_of_responsibility": "Area of responsibility:",
  "ak_sd_uah_mwh": "UAH/MWh",
  "ak_sd_the_agent": "The agent",
  "ak_sd_does_not_draw_numbers_itself": "does not draw numbers itself",
  "ak_sd_it_translates_the_request_into_a_param": ": it translates the request into a parameter and asks the same engine to recalculate the schedule. Below is what exactly will change.",
  "ak_sd_the_model_does_not_promise_an_exact_pr": "The model does not promise an exact price in hryvnias - it ranks the hours. That is enough to choose the discharge window, and it can be verified against actuals.",
  "ak_sd_vadym_s_question_from_the_12_10_meetin": "Vadym's question from the 12.10 meeting. We calculate on four numbers: the DAM price, the dispatching cost, the expected BM surplus price and the netting share in this hour.",
  "ak_sd_a_zero_in_the_schedule_means_the_plant": "A zero in the schedule means the plant must physically stop delivering. This is an agreement with the technical service, not just a number in a table.",
  "ak_sd_repair": "repair",
  "ak_sd_connectivity": "connectivity",
  "ak_sd_restriction": "restriction",
  "ak_sd_the_coefficient_is_applied": "The coefficient is applied",
  "ak_sd_exactly_once": "exactly once",
  "ak_sd_and_only_because_there_is_an_event_in": "and only because there is an event in the journal. The forecast model is trained on actual generation, where past outages are already accounted for - a second multiplier would understate the schedule twice as much as needed.",
  "ak_sd_mw": "{{n}} MW",
  "ak_sd_changed_by_the_technical_dispatcher_ev": "Changed by the technical dispatcher; every change is saved with a date because all subsequent schedules depend on it. Winter coefficients - after the meeting with Radmirteh.",
  "ak_sd_dispatch_room": "Dispatch room",
  "ak_sd_trading_schedule_mockup": "Trading schedule (mockup)",
  "ak_sd_mockup": "mockup",
  "ak_sd_demo_data_nothing_is_sent": "demo data, nothing is sent",
  "ak_sd_horizon_d_2_accuracy_noticeably_lower": "horizon D+2, accuracy noticeably lower",
  "ak_sd_horizon_d_1": "horizon D+1",
  "ak_sd_day_outside_the_submission_horizon": "day outside the submission horizon",
  "ak_sd_until_mms_submission": "until MMS submission",
  "ak_sd_10_30_1_h_18_min": "10:30 · 1 h 18 min",
  "ak_sd_just_now": "just now",
  "ak_sd_all_three_approvals_are_in_the_schedul": "All three approvals are in - the schedule goes to MMS automatically.",
  "ak_sd_generation_forecast": "Generation forecast",
  "ak_sd_delivery_schedule": "Delivery schedule",
  "ak_sd_bess_charge_discharge": "BESS charge / discharge",
  "ak_sd_expected_revenue": "Expected revenue",
  "ak_sd_technical_state": "Technical state",
  "ak_sd_median_p50": "median P50",
  "ak_sd_this_is_what_we_submit_to_mms": "this is what we submit to MMS",
  "ak_sd_cycle_efficiency_0_87": "cycle efficiency 0.87",
  "ak_sd_schedule_price_forecast_0_97": "schedule × price forecast × 0.97",
  "ak_sd_coefficient_0_97": "coefficient 0.97",
  "ak_sd_day_by_hour": "Day by hour",
  "ak_sd_price_forecast": "Price forecast",
  "ak_sd_corridor_p10_p90": "Corridor P10–P90",
  "ak_sd_generation_forecast_p50": "Generation forecast P50",
  "ak_sd_dam_price_forecast": "DAM price forecast",
  "ak_sd_discharge_window_19_00_21_00": "discharge window 19:00–21:00",
  "ak_sd_charge_window_11_00_14_00": "charge window 11:00–14:00",
  "ak_sd_tell_the_model_what_to_change": "Tell the model what to change",
  "ak_sd_write_in_plain_language_move_the_disch": "Write in plain language: \"move the discharge to 21–22, it is more expensive there\"",
  "ak_sd_recalculate": "Recalculate",
  "ak_sd_move_the_discharge_to_21_22": "move the discharge to 21–22",
  "ak_sd_apply_the_16_mw_limit_from_hour_14": "apply the 16 MW limit from hour 14",
  "ak_sd_do_not_set_zero_at_hour_14_give_the_re": "do not set zero at hour 14, give the remainder to the grid",
  "ak_sd_show_why_exactly_these_two_discharge_h": "show why exactly these two discharge hours",
  "ak_sd_the_model_proposes_a_change_confirm_or": "The model proposes a change - confirm or cancel",
  "ak_sd_discharge_window": "Discharge window",
  "ak_sd_imbalance_risk": "Imbalance risk",
  "ak_sd_uah_1_198k": "UAH 1,198k",
  "ak_sd_uah_1_186k": "UAH 1,186k",
  "ak_sd_low": "low",
  "ak_sd_medium": "medium",
  "ak_sd_apply": "Apply",
  "ak_sd_cancel": "Cancel",
  "ak_sd_the_request_and_decision_will_be_logge": "The request and decision will be logged: who asked, what changed, how it turned out against the day actuals.",
  "ak_sd_accuracy_over_7_days": "Accuracy over 7 days",
  "ak_sd_12_0_nmae": "12.0 % nMAE",
  "ak_sd_target_7": "target ≤ 7 %",
  "ak_sd_worst_day": "Worst day",
  "ak_sd_change_vs_evening": "Change vs evening",
  "ak_sd_morning_forecast_is_higher_alarm_at_08": "morning forecast is higher - alarm at 08:30",
  "ak_sd_corridor_width": "Corridor width",
  "ak_sd_variable_cloud_cover": "variable cloud cover",
  "ak_sd_hours_worth_a_look": "Hours worth a look",
  "ak_sd_hour": "Hour",
  "ak_sd_forecast_p50": "Forecast P50",
  "ak_sd_corridor": "Corridor",
  "ak_sd_schedule": "Schedule",
  "ak_sd_why": "Why",
  "ak_sd_peak_hour_hit_rate": "Peak-hour hit rate",
  "ak_sd_23_of_30_days": "23 of 30 days",
  "ak_sd_for_september": "for September",
  "ak_sd_most_expensive_hour": "Most expensive hour",
  "ak_sd_uah_mwh_corridor_20": "UAH/MWh, corridor ±20 %",
  "ak_sd_cheapest_hour": "Cheapest hour",
  "ak_sd_we_put_the_charge_here": "we put the charge here",
  "ak_sd_daily_spread": "Daily spread",
  "ak_sd_between_the_most_and_least_expensive": "between the most and least expensive",
  "ak_sd_hour_ranking_by_price": "Hour ranking by price",
  "ak_sd_cheap_hours_zero_or_give": "Cheap hours: zero or give?",
  "ak_sd_dam_price": "DAM price",
  "ak_sd_give": "Give",
  "ak_sd_zero": "Zero",
  "ak_sd_decision": "Decision",
  "ak_sd_1_2k": "+1.2k",
  "ak_sd_0_4k": "−0.4k",
  "ak_sd_0_3k": "+0.3k",
  "ak_sd_give_2": "give",
  "ak_sd_zero_2": "zero",
  "ak_sd_inverters": "Inverters",
  "ak_sd_2_at_tko_3_under_repair": "2 at TKO-3 under repair",
  "ak_sd_usable_bess_capacity": "Usable BESS capacity",
  "ak_sd_soc_now": "SOC now",
  "ak_sd_average_across_16_pcs": "average across 16 PCS",
  "ak_sd_tso_restriction": "TSO restriction",
  "ak_sd_none": "none",
  "ak_sd_event_log_basis_for_the_coefficient": "Event log - basis for the coefficient",
  "ak_sd_affects_the_schedule": "affects the schedule",
  "ak_sd_does_not_affect_the_schedule": "does not affect the schedule",
  "ak_sd_availability_coefficient": "Availability coefficient",
  "ak_sd_62_64_inverters": "= 62 / 64 inverters",
  "ak_sd_rated_parameters": "Rated parameters",
  "ak_sd_charge_power": "Charge power",
  "ak_sd_discharge_power": "Discharge power",
  "ak_sd_cycle_efficiency": "Cycle efficiency",
  "ak_sd_delivery_ceiling": "Delivery ceiling",
};

export default translations;
